import KioskConfiguration from "@/views/KioskConfiguration.vue";
import TokenHandler from "@/views/TokenHandler.vue";
import CloudSetting from "@/views/CloudSetting.vue";
import PrinterSetting from "@/views/PrinterSetting.vue";
import ConnectedDevices from "@/views/ConnectedDevices.vue";
import PaymentMethod from "@/views/PaymentMethod.vue";
import ExternalDevice from "@/views/ExternalDevice.vue";
import DeviceOptions from "@/views/DeviceOptions.vue";
import UnauthorizedAccess from "@/views/UnauthorizedAccess.vue";
import Error from "@/views/Error.vue";

export const routes = [
  {
    path: "/cloudsetting",
    name: "CloudSetting",
    component: CloudSetting
  },
  {
    path: "/connectedDevices",
    name: "ConnectedDevices",
    component: ConnectedDevices
  },

  {
    path: "/printersetting",
    name: "PrinterSetting",
    component: PrinterSetting
  },
  {
    path: "/paymentMethods",
    name: "PaymentMethods",
    component: PaymentMethod
  },
  {
    path: "/externalDevices",
    name: "ExternalDevice",
    component: ExternalDevice
  },
  {
    path: "/deviceOptions",
    name: "DeviceOptions",
    component: DeviceOptions
  },
  {
    path: "/kioskConfiguration",
    name: "KioskConfiguration",
    component: KioskConfiguration,
    meta: {
      plainLayout: true
    }
  },
  {
    path: "/token/:to/:accessToken/",
    name: "TokenHandler",
    props: true,
    component: TokenHandler,
    meta: {
      plainLayout: true
    }
  },
  {
    path: "/error/:message",
    name: "Error",
    props: true,
    component: Error,
    meta: {
      plainLayout: true
    }
  },
  {
    path: "/UnauthorizedAccess",
    name: "UnnauthorizedAccess",
    component: UnauthorizedAccess,
    meta: {
      plainLayout: true
    }
  }
];
